import { Box, Container } from "@mui/material";
import PageHero from "../../components/PageHero";
import { useStyles } from "./styles";

import ImgHero from "../../assets/images/about/hero.svg";
import ImgHeroMobile from "../../assets/images/about/hero_mobile.svg";
import TimeLines from "../../components/TimeLines";
import Team from "../../components/Team";
import { useIsMobileView } from "../../hooks/useWindowSize";

const AboutUs = () => {
  const classes = useStyles();

  const inMobile = useIsMobileView();

  return (
    <Box className={classes.root}>
      <PageHero
        colorScheme="dark_blue"
        title="About BITA"
        subTitle="Enterprise-grade technology and services to power the next generation of systematic investing"
      />
      <Container sx={{ paddingTop: 10 }}>
        <Box className={classes.section}>
          <Box className={classes.sectionTitle}>Our Company</Box>
          <Box className={classes.sectionSubTitle}>
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium doloremque
          </Box>
          <Box className={classes.sectionText}>
            LSed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
            quae ab illo inventore veritatis et quasi architecto beatae vitae
            dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
            aspernatur aut odit aut fugit, sed quia consequuntur magni dolores
            eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam
          </Box>
        </Box>
      </Container>
      <Box className={classes.imageContainer}>
        <img
          className={classes.heroImage}
          src={inMobile ? ImgHeroMobile : ImgHero}
          alt="About BITA Hero"
        />
      </Box>

      <Container>
        <Box className={classes.section}>
          <Box
            className={classes.sectionTitle}
            textAlign={{ xs: "center", md: "left" }}
            pl={{ xs: 0, md: 8 }}
            pt={{ xs: 6, md: 0 }}
          >
            Timeline
          </Box>

          <TimeLines inMobile={inMobile} />
        </Box>

        <Box className={classes.sectionDivider} />
        <Box className={classes.section}>
          <Box className={classes.sectionTitle} pt={{ xs: 6, md: 0 }}>
            Executive Team
          </Box>
          <Box className={classes.sectionText}>
            LSed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
            quae ab illo inventore veritatis et quasi architecto beatae vitae
            dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
            aspernatur aut odit aut fugit, sed quia consequuntur magni dolores
            eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam
          </Box>
        </Box>
        <Team inMobile={inMobile} />
      </Container>
    </Box>
  );
};

export default AboutUs;
